import PlayerStatistics from 'components/sports/bdm/views/PlayerStatistics'

function BdmPlayerStats({ data }) {

  const stats = [
    { code: 'CHALLENGE_WON', component: 'type2' },                //Successful / Unsuccessful challenges CHALLENGE_LOST 
    { code: 'PTY', component: 'type3' },                          //Penalties, Yellow / Red / Black Card (Score)
    { code: 'SMASH_MAX' },                                        //Fastest smash (km/h)
    { code: 'SERVE_FAULTS' },                                     //Service faults
    { code: 'CBACK_WIN_MAX' },                                    //Biggest comeback to win the game
    { code: 'LEAD_MAX' },                                         //Biggest lead
    { code: 'PTS_SERVICE' },                                      //Points scored with service
    { code: 'PTS_NOSERVICE' },                                    //Points scored without service
    { code: 'PTS_GAME' },                                         //Game points
    { code: 'PTS_MATCH' },                                        //Match points
    { code: 'PTS_CONSEC' },                                       //Most consecutive points
    { code: 'PTS_WON' },                                          //Total points won
    { code: 'PTS_PLAYED' }                                        //Total points played 
  ]
  return (<>
    <PlayerStatistics data={data?.results} stats={stats} />
  </>);
}

export default BdmPlayerStats;